const Loader = function () {
  return {
    hideLoader: null,
    showLoader: null,
  }
}

export default Loader
